module.exports = __webpack_public_path__ + "img/c.c5540cbe.svg";